import { render, staticRenderFns } from "./AssociationQueryItem.vue?vue&type=template&id=3d8b00bc&scoped=true"
import script from "./AssociationQueryItem.vue?vue&type=script&lang=js"
export * from "./AssociationQueryItem.vue?vue&type=script&lang=js"
import style0 from "./AssociationQueryItem.vue?vue&type=style&index=0&id=3d8b00bc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d8b00bc",
  null
  
)

export default component.exports